import { render, staticRenderFns } from "./riskAssessmentTemplateList.vue?vue&type=template&id=59d30a09"
import script from "./riskAssessmentTemplateList.vue?vue&type=script&lang=js"
export * from "./riskAssessmentTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports